"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firast = void 0;
var const_1 = require("./src/const");
var utils_1 = require("./src/utils");
var preservers_1 = require("./src/utils/preservers");
function firast(text, options) {
    // Complete options obj
    options = __assign(__assign({}, const_1.defaultOptions), options);
    if (!text.trim()) {
        return text;
    }
    text = " " + text + " ";
    // --- START OF PRESERVE
    text = preserve(options, text);
    // --- END OF PRESERVE
    // --- START OF PRE-FIX
    text = preFix(options, text);
    // --- END OF PRE-FIX
    // --- START OF WORD-LEVEL-FIX
    text = wordLevelFix(text, options);
    // --- END OF WORD-LEVEL-FIX
    // --- START OF FIX
    text = fix(options, text);
    // --- END OF FIX
    // --- START OF RESTORE
    text = restore(options, text);
    // --- END OF RESTORE
    // --- START OF POST-FIX
    text = postFix(options, text);
    // --- END OF POST-FIX
    return text;
}
exports.firast = firast;
function fix(options, text) {
    if (options.fixDates) {
        text = utils_1.fixDates(text);
    }
    if (options.fixPrefixZwnj) {
        text = utils_1.fixPrefixZwnj(text);
    }
    if (options.fixSuffixZwnj) {
        text = utils_1.fixSuffixZwnj(text);
    }
    if (options.fixBracesSpacing) {
        text = utils_1.fixBracesSpacing(text);
    }
    if (options.removeExtraMarks) {
        text = utils_1.removeExtraMarks(text);
    }
    if (options.fixPunctuationSpacing) {
        text = utils_1.fixPunctuationSpacing(text);
    }
    if (options.removeKashidas) {
        text = utils_1.removeKashidas(text);
    }
    // doing it again after `fixPunctuationSpacing()`
    if (options.fixBracesSpacing) {
        text = utils_1.fixBracesSpacingInside(text);
    }
    if (options.fixMiscSpacing) {
        text = utils_1.fixMiscSpacing(text);
    }
    if (options.removeDiacritics) {
        text = utils_1.removeDiacritics(text);
    }
    else if (options.fixDiacritics) {
        text = utils_1.fixDiacritics(text);
    }
    if (options.removeSpaces) {
        text = utils_1.removeSpaces(text);
    }
    if (options.fixZWNJ) {
        text = utils_1.fixZWNJLate(text);
    }
    if (options.fixLineBreaks) {
        text = utils_1.fixLineBreaks(text);
    }
    return text;
}
function wordLevelFix(text, options) {
    text = text.replace(/(^|\s+)([[({"'“«]?)(\S+)([\])}"'”»]?)(?=($|\s+))/g, function (matched, before, leadings, word) {
        // should not replace to persian chars in english phrases
        if (word.match(/[a-zA-Z\-_]{2,}/g)) {
            return matched;
        }
        // should not touch sprintf directives
        // @Ref https://stackoverflow.com/a/8915445/
        if (word.match(/%(?:\d+\$)?[+-]?(?:[ 0]|'.{1})?-?\d*(?:\.\d+)?[bcdeEufFgGosxX]/g)) {
            return matched;
        }
        // should not touch numbers in html entities
        if (word.match(/&#\d+;/g)) {
            return matched;
        }
        if (options.fixEnglishNumbers) {
            matched = utils_1.fixEnglishNumbers(matched);
        }
        if (options.fixNumeralSymbols) {
            matched = utils_1.fixNumeralSymbols(matched);
        }
        if (options.fixPunctuations) {
            matched = utils_1.fixPunctuations(matched);
        }
        if (options.fixNonPersianChars) {
            matched = utils_1.fixNonPersianChars(matched);
        }
        if (options.fixQuestionMarks) {
            matched = utils_1.fixQuestionMarks(matched);
        }
        return matched;
    });
    return text;
}
function restore(options, text) {
    if (options.preserveEntity) {
        text = preservers_1.restoreEntity(text);
    }
    if (options.preserveNbsp) {
        text = preservers_1.restoreNbsp(text);
    }
    if (options.preserveUri) {
        text = preservers_1.restoreUri(text);
    }
    if (options.preserveBrace) {
        text = preservers_1.restoreBrace(text);
    }
    if (options.preserveBracket) {
        text = preservers_1.restoreBracket(text);
    }
    if (options.preserveComment) {
        text = preservers_1.restoreComment(text);
    }
    if (options.preserveHtml) {
        text = preservers_1.restoreHtml(text);
    }
    if (options.preserveFrontmatter) {
        text = preservers_1.restoreFrontmatter(text);
    }
    return text;
}
function preFix(options, text) {
    if (options.fixEOL) {
        text = utils_1.fixEOL(text);
    }
    if (options.fixStandardChars) {
        text = utils_1.fixStandardChars(text, const_1.persianGlyphs);
    }
    if (options.fixDashes) {
        text = utils_1.fixDashes(text);
    }
    if (options.fixEllipsis) {
        text = utils_1.fixEllipsis(text);
    }
    if (options.fixEnglishQuotes) {
        text = utils_1.fixEnglishQuotes(text);
    }
    if (options.fixHamzeh) {
        if (options.fixArabicHamzeh) {
            text = utils_1.fixArabicHamzeh(text);
        }
        text = utils_1.fixHamzeh(text);
    }
    else if (options.fixSuffixZwnj) {
        if (options.fixArabicHamzeh) {
            text = utils_1.removeArabicHamzeh(text);
        }
        text = utils_1.fixSuffixSpacingHamzeh(text);
    }
    if (options.removeRLM) {
        text = utils_1.removeRLM(text);
    }
    if (options.fixZWNJ) {
        text = utils_1.fixZWNJ(text);
    }
    if (options.fixArabicNumbers) {
        text = utils_1.fixArabicNumbers(text);
    }
    return text;
}
function postFix(options, text) {
    if (options.trim) {
        text = utils_1.trim(text);
    }
    else {
        // removes single space paddings around the string
        text = text.replace(/^[ ]/g, "").replace(/[ ]$/g, "");
    }
    return text;
}
function preserve(options, text) {
    if (options.preserveFrontmatter) {
        text = preservers_1.preserveFrontmatter(text);
    }
    if (options.preserveHtml) {
        text = preservers_1.preserveHtml(text);
    }
    if (options.preserveComment) {
        text = preservers_1.preserveComment(text);
    }
    if (options.preserveBrace) {
        text = preservers_1.preserveBrace(text);
    }
    if (options.preserveBracket) {
        text = preservers_1.preserveBracket(text);
    }
    if (options.preserveUri) {
        text = preservers_1.preserveUri(text);
    }
    if (options.preserveNbsp) {
        text = preservers_1.preserveNbsp(text);
    }
    if (options.preserveEntity) {
        text = preservers_1.preserveEntity(text);
    }
    else {
        text = utils_1.decodeHTMLEntities(text);
    }
    return text;
}
